import { render } from "./ic-bag.vue?vue&type=template&id=7b7495f0&ts=true"
import script from "./ic-bag.vue?vue&type=script&lang=ts"
export * from "./ic-bag.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__